import { putApi } from "./api_instance";

export const deleteBids = async (formData, dispatch) => {
  try {
    const { message } = await putApi({
      apiUrl: `/projects/api/myBids/deListProject?projectId=${formData.projectId}`,
      sendToken: true,
      dispatch,
      data: {
        Remarks: "not required",
        reason: formData.reason,
      },
    });
    return message;
  } catch (error) {
    throw error;
  }
};
